<div class="media">
  <img [src]="contentUrl + content.mediaContent" />
</div>
